import {Pipe, PipeTransform} from '@angular/core';
import {RechteId} from "../../../core/gb-api/model/rechteId";
import {KompaktAmtnummerPipe} from "../../kompaktdarstellung/amt/kompakt-amtnummer-pipe";
import {RechteIdMeta} from "../../../core/gb-api/model/rechteIdMeta";

@Pipe({
  name: 'formatRechteId'
})
export class FormatRechteIdPipe implements PipeTransform {
  private ANZAHL_STELLEN = 6;

  constructor(private kompaktamt: KompaktAmtnummerPipe) {
  }

  transform(rechteId: RechteId | RechteIdMeta): string {
    if (!rechteId) {
      return null;
    }
    const grundbuchamtNummer = this.kompaktamt.transform(rechteId.grundbuchamt.nummer).toString();
    return grundbuchamtNummer + rechteId.rechteIdJahr + '/' + (rechteId.rechteIdNummer + Math.pow(10, this.ANZAHL_STELLEN) + "").slice(1);
  }

}
